import Head from 'next/head';
import React from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import { SchemaOrgNode } from 'services/schema-org/types';

type Props = {
  node: SchemaOrgNode | null;
};

export const SchemaOrg: React.FunctionComponent<Props> = ({ node }) => {
  return (
    <Head>
      {node && <script key="schema-org" {...jsonLdScriptProps(node)} />}
    </Head>
  );
};
